import { Icon } from 'libs/ui/Icon';

import {
  YearLabelStyled,
  YearPickerArrowStyled,
  YearPickerStyled,
} from './YearPicker.styles';

export interface YearPickerProps {
  year: number;
  onYearChange: (year: number) => void;
}

export const YearPicker = ({ year, onYearChange }: YearPickerProps) => {
  const handleYearChange = (direction: 'next' | 'prev') => {
    onYearChange(direction === 'next' ? year + 1 : year - 1);
  };
  return (
    <YearPickerStyled>
      <YearPickerArrowStyled
        direction="prev"
        onClick={() => handleYearChange('prev')}
      >
        <Icon.ChevronLeft size={16} />
      </YearPickerArrowStyled>
      <YearLabelStyled variant="captionMedium">{year}</YearLabelStyled>
      <YearPickerArrowStyled
        direction="next"
        onClick={() => handleYearChange('next')}
      >
        <Icon.ChevronRight size={16} />
      </YearPickerArrowStyled>
    </YearPickerStyled>
  );
};
